export default "__VITE_ASSET__CC0kRCPa__"